module.exports = __webpack_public_path__ + "media/featured_internships/best-jobs_logo_150x115-ca6d329f.gif";